import script from "./AlertCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertCard.vue?vue&type=script&setup=true&lang=js"

import "./AlertCard.vue?vue&type=style&index=0&id=d1cfa0b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1cfa0b6"]])

export default __exports__